import { useNavigate } from "react-router-dom";

/**
 * @typedef {import("../../../../hooks/quiz/useGetClassroomOverview").ClassroomOverviewData} ClassroomOverviewData
 */

/**
 * @param {Object} props
 * @param {ClassroomOverviewData} props.classroom
 * @param {boolean} props.disabled
 */
const QuizOverviewTableRow = ({ classroom, disabled }) => {
  const navigate = useNavigate();

  const handleRowClick = () => {
    if (disabled) return;
    navigate(`/teacher/quiz/classroom/${classroom.classroom_id}`, {
      state: {
        classroomName: classroom.classroom_name,
      },
    });
  };

  return (
    <tr onClick={handleRowClick} style={{ cursor: "pointer" }}>
      <td>{classroom.classroom_name || "-"}</td>
      <td className="text-center">{classroom.students_count ?? 0}</td>
      <td className="text-center">
        {classroom.classroom_limit !== null ? classroom.classroom_limit : "Unlimited"}
      </td>
      <td className="text-center">
        {classroom.extended ? (
          <span className="badge bg-success">Yes</span>
        ) : (
          <span className="badge bg-secondary">No</span>
        )}
      </td>
      <td className="text-center">{classroom.exhausted_students ?? 0}</td>
    </tr>
  );
};

export default QuizOverviewTableRow;
